import {
	InjectionToken,
	Type,
} from '@angular/core';

export interface ICommonAppConfig {
	readonly application: string;
	readonly hasInitialLoader: boolean;
	readonly shouldAuthorize: boolean;
	readonly shouldInitLayoutService: boolean;
	readonly mainComponent: Type<any>;
}

export const COMMON_APP_CONFIG = new InjectionToken<ICommonAppConfig>('COMMON_APP_CONFIG');
